import { type SocialAssetWithProject } from '../../../shared/types';
import { STATUS_LABELS, TYPE_LABELS } from '../../lib/socialCalendar';

export function StatusPill({ asset }: { asset: SocialAssetWithProject }) {
  if (asset.effective_restricted) return <span className="pill danger">restricted</span>;
  if (asset.status === 'used') return <span className="pill">used</span>;
  const tone = asset.status === 'ready' ? 'ok' : asset.status === 'needs_prep' ? 'gold' : 'accent';
  return <span className={`pill ${tone}`}>{STATUS_LABELS[asset.status]}</span>;
}

/** "social-made · MRG Brand Package · hsp" — the sheet eyebrow and the row
    meta line read the same three facts. */
export function assetContext(asset: SocialAssetWithProject): string {
  return [TYPE_LABELS[asset.type], asset.project_name ?? 'standalone', asset.brand].join(' · ');
}
